import { UserState } from "./types";
import { User } from "@/models/user_schema";
import { Roles } from "@/models/roles";
import { SalesRegions } from '@/models/map/region_type';

export const getUser = (state: UserState): User => {
  return state.user;
};

export const getRole = (state: UserState): Roles => {
  return state.user.role;
};

export const getSalesRegion = (state: UserState): SalesRegions["string"] | '' => {
  return state.user.role === Roles.SalesRep ? state.user.rep_info!.sales_region : '';
};

export const getErrorState = (state: UserState): boolean => {
  return state.error;
};
